(() => {
  if (window.BandenmeestersCartRuntimeLoaded) {
    window.BandenmeestersCartRenderVehicle?.();
    return;
  }
  window.BandenmeestersCartRuntimeLoaded = true;

  const normalizePath = (value) => {
    if (!value) return '';
    try { return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/'; }
    catch (error) { return String(value).split('?')[0].split('#')[0].replace(/\/$/, ''); }
  };

  const splitData = (value) => String(value || '').split('|').map((entry) => entry.trim()).filter(Boolean);

  const resolveLineFitment = (line, vehicle) => {
    if (!vehicle?.generation?.id || line?.dataset?.productType !== 'Velgenset') return null;
    const ids = splitData(line.dataset.fitmentIds);
    if (ids.length) return ids.includes(String(vehicle.generation.id));
    const urls = splitData(line.dataset.fitmentUrls).map(normalizePath).filter(Boolean);
    const activeUrl = normalizePath(vehicle.generation.url);
    if (urls.length && activeUrl) return urls.includes(activeUrl);
    return null;
  };

  const renderLineFitment = (vehicle) => {
    const uniqueResults = new Map();
    document.querySelectorAll('[data-bm-cart-line]').forEach((line, index) => {
      const status = line.querySelector('[data-bm-line-fitment]');
      const text = status?.querySelector('[data-bm-line-fitment-text]');
      const isWheelset = line.dataset.productType === 'Velgenset';
      if (!status || !isWheelset || !vehicle) {
        if (status) status.hidden = true;
        return;
      }

      const result = resolveLineFitment(line, vehicle);
      const resultKey = line.dataset.variantId || `line-${index}`;
      if (!uniqueResults.has(resultKey)) uniqueResults.set(resultKey, result);
      status.hidden = false;
      status.classList.remove('is-match', 'is-warning', 'is-neutral');
      if (result === true) {
        status.classList.add('is-match');
        if (text) text.textContent = 'Gekoppeld aan jouw gekozen generatie';
      } else if (result === false) {
        status.classList.add('is-warning');
        if (text) text.textContent = 'Niet gekoppeld aan jouw gekozen generatie';
      } else {
        status.classList.add('is-neutral');
        if (text) text.textContent = 'Passing niet automatisch bevestigd';
      }
    });
    return [...uniqueResults.values()];
  };

  const renderVehicle = () => {
    const api = window.BandenmeestersVehicle;
    const vehicle = api?.getActive?.() || null;
    const label = vehicle ? (api?.vehicleLabel?.(vehicle) || [vehicle?.brand?.name, vehicle?.generation?.name || vehicle?.model?.name].filter(Boolean).join(' ')) : '';
    const results = renderLineFitment(vehicle);
    const hasMismatch = results.some((result) => result === false);
    const hasUnknown = results.some((result) => result === null);
    const allMatched = results.length > 0 && results.every((result) => result === true);

    document.querySelectorAll('[data-bm-cart-vehicle]').forEach((root) => {
      const title = root.querySelector('[data-bm-cart-vehicle-label]');
      const detail = root.querySelector('[data-bm-cart-vehicle-detail]');
      const action = root.querySelector('[data-bm-vehicle-change-link]');
      root.classList.remove('has-vehicle', 'is-warning', 'is-match', 'is-neutral');
      root.classList.add(vehicle ? 'has-vehicle' : 'is-neutral');

      if (title) title.textContent = vehicle ? label : 'Nog geen auto geselecteerd';
      if (action) action.textContent = vehicle ? 'Wijzig' : 'Kies auto';

      if (!detail) return;
      if (!vehicle) {
        detail.textContent = 'Kies merk, model en generatie om de passing te controleren.';
      } else if (hasMismatch) {
        root.classList.add('is-warning');
        detail.textContent = results.length === 1
          ? 'Deze set is niet gekoppeld aan jouw gekozen generatie. Controleer de passing vóór bestellen.'
          : 'Minstens één set is niet gekoppeld aan jouw gekozen generatie. Controleer de passing vóór bestellen.';
      } else if (allMatched) {
        root.classList.add('is-match');
        detail.textContent = results.length === 1
          ? 'Deze set is gekoppeld aan jouw gekozen generatie.'
          : 'Alle velgensets zijn gekoppeld aan jouw gekozen generatie.';
      } else if (hasUnknown || !results.length) {
        root.classList.add('is-neutral');
        detail.textContent = 'De passing is niet voor iedere set automatisch bevestigd. Controleer de productgegevens vóór bestellen.';
      }
    });
  };

  window.BandenmeestersCartRenderVehicle = renderVehicle;

  const init = () => {
    renderVehicle();
    window.addEventListener('bm:vehicle:change', renderVehicle);
    document.addEventListener('bm:vehicle:ready', renderVehicle);
    window.addEventListener('pageshow', renderVehicle);
    ['cart:item-add', 'cart:item-remove', 'cart:item-quantity-update'].forEach((name) => document.addEventListener(name, () => requestAnimationFrame(renderVehicle)));

    document.addEventListener('click', (event) => {
      if (event.target.closest?.('.bm-mini-cart [data-bm-vehicle-change-link]')) window.miniCart?.close?.();
    }, true);

    const observer = new MutationObserver((mutations) => {
      const cartMarkupChanged = mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('[data-bm-cart-vehicle],[data-bm-cart-line]') || node.querySelector?.('[data-bm-cart-vehicle],[data-bm-cart-line]'))));
      if (!cartMarkupChanged) return;
      requestAnimationFrame(renderVehicle);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
